import { useFeatureFlagEnabled } from "posthog-js/react"

export const IMAGE_SEARCH_FEATURE_FLAG = "image_search"
export function useImageSearchAccessState(): "loading" | "allowed" | "denied" {
  const enabled = useFeatureFlagEnabled(IMAGE_SEARCH_FEATURE_FLAG)
  if (enabled === false) return "denied"
  return enabled === true ? "allowed" : "loading"
}

export function useImageSearchAccess() {
  return useImageSearchAccessState() === "allowed"
}
